import {
  Checkbox as MUICheckbox,
  CheckboxProps as MUICheckboxProps,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Box,
} from "@mui/material";
import { useMemo } from "react";

const boxStyle = {
  border: "1px solid #00000040",
  padding: "6px 14px",
  width: "inherit",
};

const errorBoxStyle = {
  border: "1px solid #D32F2F",
};

export type CheckboxProps = Omit<MUICheckboxProps, "name"> & {
  fullWidth?: boolean;
  variant?: "outlined";
  error?: any;
  label?: string;
  helperText?: string;
};

export const Checkbox = (props: CheckboxProps) => {
  const { required, error, fullWidth, variant, label, ...rest } = props;

  const sx = useMemo(
    () => ({
      ...(variant === "outlined" ? boxStyle : {}),
      ...(error ? errorBoxStyle : {}),
      ...rest.sx,
    }),
    [error, rest.sx, variant]
  );

  return (
    <FormControl
      required={required}
      error={!!error}
      sx={{ width: fullWidth ? "100%" : "auto" }}
    >
      <FormGroup row sx={{ width: "inherit" }}>
        <Box sx={sx}>
          <FormControlLabel
            label={label || ""}
            control={
              <MUICheckbox
                {...rest}
                color={rest.color || "primary"}
                sx={{
                  ...rest.sx,
                  color: error ? "error.main" : undefined,
                }}
              />
            }
          />
        </Box>
      </FormGroup>
      <FormHelperText>{error?.message ?? null}</FormHelperText>
    </FormControl>
  );
};
